import "./TextInputSelectComp.css";
import { defineComponent as v, resolveComponent as o, openBlock as a, createElementBlock as h, normalizeClass as V, normalizeStyle as C, createVNode as n, withCtx as l, withKeys as r, Fragment as S, renderList as M, createBlock as m, createElementVNode as f, toDisplayString as c, createCommentVNode as F } from "vue";
import { V as I, W as $ } from "./WrapperComp.f674f2c9.js";
import { ButtonComp as B } from "./ButtonComp.js";
import { OverflowComp as A } from "./OverflowComp.js";
import { InputComp as O } from "./InputComp.js";
import { IconComp as T } from "./IconComp.js";
import { i as d } from "./isNil.6f60d6a4.js";
import { u as k } from "./uniqueId.f48d78c2.js";
import { i as E } from "./isEqual.398c54af.js";
import { _ as K } from "./_plugin-vue_export-helper.dad06003.js";
const q = v({
  mixins: [I],
  components: {
    ButtonComp: B,
    OverflowComp: A,
    InputComp: O,
    IconComp: T,
    WrapperComp: $
  },
  events: {
    "update:modelValue": {
      type: Object
    },
    "update:errorMessages": {
      type: Array,
      Note: "Updates the Error message array"
    }
  },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => k("textInputSelectComp")
    },
    modelValue: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => [],
      Note: 'This is the secondary v-model:errorMessages="" of the component'
    },
    infoMessages: {
      type: Array,
      default: () => []
    },
    placeholder: String,
    emptyText: String,
    label: String,
    supportingText: String,
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    },
    legacy: Boolean,
    width: String,
    allowAdHocValue: Boolean,
    disabled: Boolean,
    labelAbove: Boolean
  },
  data() {
    return {
      show: !1,
      inputValue: null,
      parentFocused: !1,
      childFocused: !1
    };
  },
  computed: {
    displayValue: {
      get() {
        return this.inputValue !== null ? this.inputValue : d(this.modelValue) ? "" : this.modelValue.text;
      },
      set(e) {
        this.inputValue = e;
      }
    },
    styleOverrides() {
      return {
        width: this.width
      };
    },
    filteredOptions() {
      return d(this.inputValue) ? this.options : this.options.filter(
        (e) => e.text.toLowerCase().includes((this.inputValue ?? "").toLowerCase())
      );
    },
    filled() {
      return this.displayValue !== "";
    },
    hasPlaceholder() {
      var e;
      return !!((e = this.placeholder) != null && e.trim());
    }
  },
  methods: {
    isEqualComparison(e, t) {
      return E(e, t);
    },
    async handleBlur() {
      this.parentFocused = !1, await this.sleep(100), this.childFocused || await this.close();
    },
    async handleKeyEnter() {
      if (!this.show) {
        this.open();
        return;
      }
      this.filteredOptions.length === 1 && await this.handleChildClick(this.filteredOptions[0]);
    },
    async handleChildClick(e) {
      this.$emit("update:modelValue", e), await this.close(!0);
    },
    handleChildFocus() {
      this.childFocused = !0;
    },
    async handleChildBlur() {
      this.childFocused = !1, await this.sleep(100), this.childFocused || await this.close();
    },
    async handleChildKeyTab() {
      await this.sleep(100), !this.parentFocused && !this.childFocused && await this.close();
    },
    async handleFocus() {
      this.show ? await this.close() : this.open();
    },
    open() {
      this.disabled || this.show || (this.parentFocused = !0, this.show = !0);
    },
    async close(e = !1) {
      if (this.show) {
        if (this.show = !1, await this.sleep(150), this.allowAdHocValue && !e && !d(this.inputValue)) {
          const t = {
            text: this.inputValue,
            value: this.inputValue
          };
          await this.$emit("update:modelValue", t);
        }
        this.inputValue === "" && await this.$emit("update:modelValue", null), this.inputValue = null, this.validateInputOnBlur();
      }
    },
    async sleep(e) {
      return new Promise((t) => setTimeout(t, e));
    },
    validate() {
      const e = this.runValidationMethod(this.modelValue);
      return this.$emit("update:errorMessages", e), e.filter((t) => t.id === this.id);
    }
  }
});
function N(e, t, D, P, R, L) {
  const y = o("icon-comp"), w = o("input-comp"), u = o("button-comp"), b = o("overflow-comp"), g = o("wrapper-comp");
  return a(), h("div", {
    class: V(["textInputSelect", {
      "textInputSelect--legacy": e.legacy,
      "textInputSelect--filled": e.filled,
      "textInputSelect--focused": e.show,
      "textInputSelect--disabled": e.disabled,
      "textInputSelect--error": e.isErrorState,
      "textInputSelect--placeholder": e.placeholder
    }]),
    style: C(e.styleOverrides)
  }, [
    n(g, {
      id: e.id,
      label: e.label,
      supportingText: e.supportingText,
      validationRules: e.validationRules,
      errorMessages: e.errorMessages,
      infoMessages: e.infoMessages,
      disableMessages: e.disableMessages,
      disabled: e.disabled,
      labelAbove: e.labelAbove,
      hasPlaceholder: e.hasPlaceholder,
      isFocused: e.show,
      filled: e.filled
    }, {
      default: l(() => [
        n(b, {
          offsetDistance: "2px",
          disabled: e.disabled,
          show: e.show,
          width: "100%"
        }, {
          button: l(() => [
            n(w, {
              id: e.id,
              type: "text",
              modelValue: e.displayValue,
              "onUpdate:modelValue": [
                t[0] || (t[0] = (s) => e.displayValue = s),
                t[1] || (t[1] = (s) => e.open())
              ],
              onFocus: t[2] || (t[2] = (s) => e.handleFocus()),
              onBlur: t[3] || (t[3] = (s) => e.handleBlur()),
              onKeyup: [
                t[4] || (t[4] = r((s) => e.handleKeyEnter(), ["enter"])),
                t[5] || (t[5] = r((s) => e.close(), ["esc"]))
              ],
              class: "textInputSelect__button",
              placeholder: e.placeholder,
              errorMessages: e.errorMessages,
              disableMessages: "",
              selectAllOnFocus: "",
              legacy: e.legacy,
              disabled: e.disabled
            }, {
              append: l(() => [
                n(y, {
                  class: "textInputSelect__appendedIcon",
                  icon: "expand_more_small"
                })
              ]),
              _: 1
            }, 8, ["id", "modelValue", "placeholder", "errorMessages", "legacy", "disabled"])
          ]),
          content: l(() => [
            (a(!0), h(S, null, M(e.filteredOptions, (s) => {
              var p;
              return a(), m(u, {
                key: s.text,
                onClick: (i) => e.handleChildClick(s),
                onFocus: t[6] || (t[6] = (i) => e.handleChildFocus()),
                onBlur: t[7] || (t[7] = (i) => e.handleChildBlur()),
                onKeydown: t[8] || (t[8] = r((i) => e.handleChildKeyTab(), ["tab"])),
                onKeyup: t[9] || (t[9] = r((i) => e.close(), ["esc"])),
                dropdown: "",
                dropdownSelected: e.isEqualComparison(s.value, (p = e.modelValue) == null ? void 0 : p.value),
                dropdownDisabled: s.disabled,
                "t-sel": s.tSel
              }, {
                default: l(() => [
                  f("p", null, c(s.text), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "dropdownSelected", "dropdownDisabled", "t-sel"]);
            }), 128)),
            e.filteredOptions.length === 0 ? (a(), m(u, {
              key: 0,
              class: "textInputSelect__emptyText",
              dropdown: "",
              dropdownDisabled: ""
            }, {
              default: l(() => [
                f("p", null, c(e.emptyText), 1)
              ]),
              _: 1
            })) : F("", !0)
          ]),
          _: 1
        }, 8, ["disabled", "show"])
      ]),
      _: 1
    }, 8, ["id", "label", "supportingText", "validationRules", "errorMessages", "infoMessages", "disableMessages", "disabled", "labelAbove", "hasPlaceholder", "isFocused", "filled"])
  ], 6);
}
const x = /* @__PURE__ */ K(q, [["render", N], ["__scopeId", "data-v-8c9961db"]]);
export {
  x as TextInputSelectComp
};
//# sourceMappingURL=TextInputSelectComp.js.map
